import "../styles/App.css";
import useWindowDimensions from "../helpers";
import { useState } from "react";

interface props {
    short: boolean;
}

const Bio = (props: props) => {
    const { short } = props;
    const width = useWindowDimensions().width;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [data, setData] = useState(false);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const rotatingQuote = (
        <p>
            Sometimes, I wonder if I would know a beautiful thing
            <br />
            if I saw it. So often, I was miserable when I was young,
            <br />
            even in California with the ocean close and fat seals
            <br />
            munching flatfish, tonguing urchins in their molars,
            <br />
            sunning themselves pink by the sandy primrose. I ignored
            <br />
            the whistle of the rock-faced mountain and her chorus
            <br />
            of dry hills, walked past the blazing stars and lemons in
            <br />
            dramatic ripe. I was so sad out west. The truth is I am
            <br />
            most exquisite on the east coast, meaning I am in rhythm.
            <br />
            I do not track the world by beauty but joy. That first bite
            <br />
            into the soft carrot of tagine stew while a storm wailed
            <br />
            over the East River. The misfit raccoon bouncing on
            <br />
            trash bins in Central Park after we saw a Japanese play.
            <br />
            We almost crashed a wedding that night at the Boathouse
            <br />
            but lost our nerve. We were not dressed for the caper,
            <br />
            but even this felt like rogue joy. Yes. It was joy, wasn't it?
            <br />
            Even if it was ugly, it was joy.
            <br />
            <br />
            <div className="rowEnd">-Megan Fernandes, "Love Poem"</div>
        </p>
    );

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const rotatingQuoteMobileSize = (
        <p>
            Sometimes, I wonder if I would know a beautiful thing / if I saw it. So often, I was miserable when I was young, / even in California with the ocean close and fat seals / munching
            flatfish, tonguing urchins in their molars, / sunning themselves pink by the sandy primrose. I ignored / the whistle of the rock-faced mountain and her chorus / of dry hills, walked past
            the blazing stars and lemons in / dramatic ripe. I was so sad out west. The truth is I am / most exquisite on the east coast, meaning I am in rhythm. / I do not track the world by beauty
            but joy. That first bite / into the soft carrot of tagine stew while a storm wailed / over the East River. The misfit raccoon bouncing on / trash bins in Central Park after we saw a
            Japanese play. / We almost crashed a wedding that night at the Boathouse / but lost our nerve. We were not dressed for the caper, / but even this felt like rogue joy. Yes. It was joy,
            wasn't it? / Even if it was ugly, it was joy.
            <br />
            <br />
            <div className="rowEnd">-Megan Fernandes, "Love Poem"</div>
        </p>
    );

    const shortBio = (
        <p>
            Amy Y.Q. Lin is a writer and pianist. Her writing is published in <i>Catapult</i>, <i>The Rumpus</i>, <i>Los Angeles Review of Books</i>, <i>The Creative Independent</i>, <i>One Story</i>,
            and elsewhere. A finalist for the 2026 <i>Fractured Lit</i> Fractured and Fused Prize, she has received residencies and scholarships from The Seattle Public Library, Tin House,{" "}
            <i>The Kenyon Review</i>, and Sewanee Writers' Conference. Lin holds an MFA in Fiction from NYU and BA in Computer Science from Cornell University. She is working on her first novel.
        </p>
    );

    const engineeringAndGameDesignBackground = (
        <div>
            <div className="paragraph">
                Prior to writing, Amy was a software engineer in the video games industry, launching the Xbox Game Pass subscription and Xbox apps on PC and mobile. During her time at Microsoft, she
                drove performance improvements that significantly reduced app startup time, spearheaded a weekly livestream on the official Xbox channel on Twitch, and led DEI initiatives for Early in
                Career and AAPI communities. Amy also launched major revenue-driving experiences, including cloud streaming, third-party integrations with Ubisoft and EA, a new family subscription
                type, and the global expansion of Game Pass to Southeast Asian markets. She has engineering experience in web, PC and mobile app development using React, React Native, TypeScript, and
                Redux. She received her BA in Computer Science from Cornell University.
            </div>
            <div className="paragraph">
                On the side, Amy has developed and published personal projects in artificial intelligence and virtual reality, including award-winning simulations, adversarial bots, and video games.
                At the Riot Games Hackathon in 2017, her team's League of Legends home theater simulation won first place as a fresh visualization tool for advancing VR streaming entertainment. In
                2017, Amy also created an AI solver to play Bananagrams and win the game faster than human opponents via the application of game tree search, randomized algorithms, and hill climbing.
                Her project received the Workday-sponsored award at Cornell University's cutting-edge technology showcase, BITS ON OUR MINDS (BOOM) 2018. In 2018 and 2016, Amy designed, engineered,
                and created the soundtrack for two games, <i>Direkt</i> and <i>Fara Heim</i>, puzzle games published on Kongregate and Newgrounds that she and her team evolved from player feedback and
                data analytics to improve level progression and player retention. In college, she worked in a cross-functional project team of mechanical engineers, electrical engineers, and software
                engineers on the development of a Star Wars rollercoaster VR simulation that integrated with a Moog motion platform, physical interactive models, and mobile app controllers to provide
                sensory feedback for real-world performance prediction.
            </div>
            <div className="paragraph">Occasionally she makes websites from scratch in React, including this one and her wedding website.</div>
            <div className="paragraph">Once upon a time, she was also a professional video game streamer.</div>
        </div>
    );

    return (
        <div>
            {short ? (
                width < 1300 ? (
                    <div>
                        {shortBio}
                        {/* {rotatingQuoteMobileSize} */}
                    </div>
                ) : (
                    <div>
                        {shortBio}
                        {/* {rotatingQuote} */}
                    </div>
                )
            ) : (
                <text>
                    <div className="paragraph">
                        Amy Y.Q. Lin is a writer and pianist living in Seattle. Her writing is published in <i>Catapult</i>, <i>The Rumpus</i>, <i>Los Angeles Review of Books</i>,{" "}
                        <i>The Creative Independent</i>, <i>One Story</i>, and elsewhere. A finalist for the 2026 <i>Fractured Lit</i> Fractured and Fused Prize and a semi-finalist for the 2022{" "}
                        <i>Sewanee Review</i> Fiction Contest, she has received residencies and scholarships from The Seattle Public Library, Tin House, <i>The Kenyon Review</i>, and Sewanee Writers'
                        Conference.
                    </div>
                    <div className="paragraph">
                        She received her MFA in Creative Writing in 2025 from New York University, where she worked with Jeffrey Eugenides, Garth Greenwell, Katie Kitamura, Raven Leilani, David
                        Lipsky, Jonas Hassen Khemiri, and Hannah Tinti.
                    </div>
                    <div className="paragraph">
                        At NYU, Amy was an adjunct professor in the English department. She taught an undergraduate course called "Introduction to Prose and Poetry," a combined creative writing
                        workshop and craft class. Students came away with a strong writing portfolio, a new understanding of storytelling techniques, and the tools to critique others' works with
                        respect and professionalism. She has also taught classical piano lessons at Cornell University and from her private studio.
                    </div>
                    <div className="paragraph">
                        Amy served as Fiction Editor and Books Editor for <i>Washington Square Review</i>, an award-winning literary magazine, from 2022-2024, where she managed a team of two editors
                        and three assistant editors, solicited writers, curated short stories and book reviews for two print issues and the digital features section, and managed content reading,
                        selection, assignment, editing, and publication schedules. She has been a reader for <i>One Story</i> and the digital anthology <i>Best of the Net</i>.
                    </div>
                    <div className="paragraph">
                        Amy volunteers on the Board of Directors as Vice President for Seattle City of Literature to manage Seattle's designation as a UNESCO City of Literature on behalf of the
                        municipality. She also serves as a Program Advisory Committee Member for the BS programs in Computer Science and Game Design at DigiPen Institute of Technology.
                    </div>
                    <div className="paragraph">
                        In addition to creative writing, Amy works in marketing and product management. She writes and edits articles for a software development blog and clients in healthcare,
                        banking, finance, insurance, and e-commerce. She PMs for a romantasy startup.
                    </div>
                    {!data && (
                        <button className="linkNoUnderline" onClick={() => setData(true)}>
                            ...read on about her engineering and game design experience
                        </button>
                    )}
                    {data && engineeringAndGameDesignBackground}
                </text>
            )}
        </div>
    );
};

export default Bio;
